

































































import { Component, Vue } from 'vue-property-decorator';
import { TableStripe } from '@/mixins/tableStripe';
import { institutionServer, performanceServer, safetyAndEnvironmentAssessmentServer, userServe } from '@/api/installServer';
import { arrayToTree } from '@/util/arrayToTree';

@Component({
  components: {},
  mixins: [TableStripe],
})
export default class CheckDialog extends Vue {
  private visible = false;
  // 树形图的数组
  defaultProps: object = {
    children: 'children',
    label: 'name',
  };
  formData: any = {
    assessProject: '',
  };
  deptData: any = []; // 部门
  postData: any = []; // 岗位
  personData: any = []; // 人员
  newDeptData: any = [];
  selectObj: any = {};
  // selectObjPost: any = {};
  selectObjPost: any = [];
  selectObjPerson: any = {};

  private async showDialog(deptData: any, postData: any, personData: any) {
    console.log(personData);
    this.visible = true;
    const newA: any = await this.getSubSpaceByAuth();
    if (newA && deptData.id) {
      this.newDeptData.forEach((re: any) => {
        if (deptData.id === re.id) {
          (this.$refs['multipleDeptTable'] as any).toggleRowSelection(re);
        }
      });
      const newPerson: any = await this.getSpaceStaffTwoByAuth(deptData.id);
      if (newPerson && personData.id) {
        setTimeout(() => {
          this.personData.forEach((re1: any) => {
            if (personData.id === re1.id) {
              (this.$refs['multiplePersonTable'] as any).toggleRowSelection(re1);
            }
          });
        }, 200);
      }

      // const newB: any = await this.getSpacePostByAuth(deptData.id);
      if (postData && postData.length > 0) {
        setTimeout(() => {
          this.postData.forEach((re1: any) => {
            postData.forEach((r: any) => {
              if (r.postId === re1.postId) {
                (this.$refs['multiplePostTable'] as any).toggleRowSelection(re1);
              }
            });
          });
        }, 300);
      }
    }
  }

  getPostlist(data: any) {
    const newList: any = [];
    if (data && data.length > 0) {
      data.forEach((res: any) => {
        newList.push(res.postName);
      });
      return '(' + newList.join('、') + ')';
    } else {
      return '';
    }
  }

  /**
   * @description 将选中的数组赋值给传递的数组
   */
  tableChange(val: any) {
    this.selectObj = {};
    this.postData = [];
    this.personData = [];
    // this.selectObjPost = {};
    this.selectObjPost = [];
    this.selectObjPerson = {};
    if (val.length > 1) {
      (this.$refs['multipleDeptTable'] as any).clearSelection();
      (this.$refs['multipleDeptTable'] as any).toggleRowSelection(val[val.length - 1]);
    }
    if (val && val.length > 0) {
      // this.selectObj 就是选中的对象数据
      this.selectObj = val[val.length - 1];
      this.getSpaceStaffTwoByAuth(this.selectObj.id);
    }

    if (!this.selectObj) {
      this.selectObj = {};
    }
  }

  currentChange(val: any) {
    (this.$refs['multipleDeptTable'] as any).toggleRowSelection(val);
  }

  /**
   * @description 将选中的数组赋值给传递的数组
   */
  tableChange1(val: any) {
    this.selectObjPost = val;
    // this.personData = [];
    // this.selectObjPerson = {};
    // if (val.length > 1) {
    //   (this.$refs['multiplePostTable'] as any).clearSelection();
    //   (this.$refs['multiplePostTable'] as any).toggleRowSelection(val[val.length - 1]);
    // }

    // if (val && val.length > 0) {
    // this.selectObj 就是选中的对象数据
    // this.selectObjPost = val[val.length - 1];
    // if (this.selectObjPost && this.selectObjPost.id) {
    //   this.getSpaceStaffTwoByAuth(this.selectObjPost.id);
    // }
    // }
    // if (!this.selectObjPost) {
    //   this.selectObjPost = {};
    // }
  }

  currentChange1(val: any) {
    (this.$refs['multiplePostTable'] as any).toggleRowSelection(val);
  }

  /**
   * @description 将选中的数组赋值给传递的数组
   */
  tableChange2(val: any) {
    // this.selectObjPost = {};
    this.selectObjPost = [];
    this.postData = [];
    if (val.length > 1) {
      (this.$refs['multiplePersonTable'] as any).clearSelection();
      (this.$refs['multiplePersonTable'] as any).toggleRowSelection(val[val.length - 1]);
    }
    if (val && val.length > 0) {
      // this.selectObj 就是选中的对象数据
      this.selectObjPerson = val[val.length - 1];
      if (this.selectObjPerson && this.selectObjPerson.id) {
        this.postData = this.selectObjPerson.postList;
        // this.getSpacePostByAuth(this.selectObj.id);
      }
    } else {
      this.selectObjPerson = {};
    }
    if (!this.selectObjPerson) {
      this.selectObjPerson = {};
    }
  }

  currentChange2(val: any) {
    (this.$refs['multiplePersonTable'] as any).toggleRowSelection(val);
  }

  /**
   * @description 点击返回按钮 关闭弹窗
   */
  returnDialog() {
    this.visible = false;
  }

  /**
   * @description 点击保存按钮
   */
  saveDialog() {
    // if (this.selectObjPerson.hasOwnProperty('name')) {
    this.$emit('getDeptOrPersonData', this.selectObj, this.selectObjPost, this.selectObjPerson);
    this.visible = false;
    // } else {
    //   this.$message.warning('请选择部门下的人员');
    // }
  }

  /**
   * @desc 获取部门所有数据
   * @param1 暂无
   * @returns 暂无
   */
  getSubSpaceByAuth() {
    // 发起接口请求，获取分页数据
    const newData: any = new Promise(resolve => {
      institutionServer
        .getAllData({})
        .then((res: any) => {
          this.newDeptData = res.data;
          this.deptData = arrayToTree(res.data);
          resolve(true);
        })
        .catch((error: any) => {
          this.$message.error('获取数据失败');
        });
    });
    return newData;
  }

  /**
   * @desc 获取岗位数据
   * @param1 暂无
   * @returns 暂无
   */
  getSpacePostByAuth(id: any) {
    // 发起接口请求，获取分页数据
    const newData: any = new Promise(resolve => {
      performanceServer
        .getSpacePostByAuth({ deptId: id })
        .then((res: any) => {
          this.postData = res.data;
          resolve(true);
        })
        .catch((error: any) => {
          this.$message.error('获取数据失败');
        });
    });
    return newData;
  }

  /**
   * @desc 获取人员数据
   * @param1 暂无
   * @returns 暂无
   */
  getSpaceStaffTwoByAuth(id: any) {
    // 发起接口请求，获取分页数据
    const newData: any = new Promise(resolve => {
      userServe
        .getPageDataAll({
          deptId: id,
        })
        .then((res: any) => {
          this.personData = res.data;
          resolve(true);
          this.$forceUpdate();
        })
        .catch((error: any) => {
          this.$message.error('获取数据失败');
        });
    });
    return newData;
  }
}
